<ca-modal-container modalTitle="{{ 'WORKFLOWS.DETAIL_PAGE.UNPUBLISH_WORKFLOW_TITLE' | translate }}" (dismiss)="dismiss('Canceled')">
    <form [formGroup]="unpublishFormGroup" (ngSubmit)="submit()">
        <div>
            <div class="d-flex flex-column-reverse">
                <textarea
                    class="form-control"
                    formControlName="comments"
                    id="comments"
                    placeholder="{{ 'WORKFLOWS.EDITOR.ENTER_UNPUBLISH_REASONS' | translate }}"
                    data-uit="unpublish-workflow-modal-comment-text-area"
                    [ngClass]="unpublishFormGroup.get('comments')?.errors ? 'has-error' : ''"
                ></textarea>
                <label for="comments">{{ 'WORKFLOWS.EDITOR.COMMENTS_FOR_OWNER' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="unpublishFormGroup.get('comments')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <div class="modal-buttons">
                <button
                    type="submit"
                    [disabled]="unpublishFormGroup.invalid"
                    class="btn btn-primary mt-2 btn-submit"
                    data-uit="workflow-unpublish-modal-unpublish-button"
                >
                    {{ 'WORKFLOWS.UNPUBLISH' | translate }}
                </button>
            </div>
        </div>
    </form>
</ca-modal-container>
